import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
// Third party packages
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs/operators";
// Custom packages
import { PlatformNotesService } from 'src/app/components/platform-note-card/platformNotes.service';
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
var AssociateBalancesPlatformNoteDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function AssociateBalancesPlatformNoteDialogComponent(dialogRef, data, configService, toastrService, cookieService, translateService, helperService, authService, apiService, platformNotesService, propertiesService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.configService = configService;
        this.toastrService = toastrService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.helperService = helperService;
        this.authService = authService;
        this.apiService = apiService;
        this.platformNotesService = platformNotesService;
        this.propertiesService = propertiesService;
        this.subscriptions = [];
        this.user = new User();
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add subUser form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.confirm"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true
            }
        };
        // END - Add subUser form
        this.dialogIsLoading = true;
        this.balances = [];
        this.selectAll = false;
        this.filterProperty = "";
        dialogRef.disableClose = true;
    }
    /**
     * Init component
     *
     */
    AssociateBalancesPlatformNoteDialogComponent.prototype.ngOnInit = function () {
        var e_1, _a;
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        var open = this.translateService.instant("balances.status.open");
        var closed = this.translateService.instant("balances.status.closed");
        var pending = this.translateService.instant("balances.status.pending");
        var propertyBalances = [];
        if (this.data.propertyBalances &&
            Array.isArray(this.data.propertyBalances)) {
            propertyBalances = this.data.propertyBalances;
        }
        // View data
        if (this.data.propertyBalances && Array.isArray(this.data.propertyBalances)) {
            try {
                for (var _b = tslib_1.__values(this.data.propertyBalances), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    if (item.status !== 'closed') {
                        this.balances.push({
                            id: item._id,
                            number: item.number,
                            status: item.status === 'open' ? open : pending,
                            value: this.data.balances && this.data.balances.includes(item._id.toString()) ? true : false,
                            visible: true,
                        });
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // Stop loading dialog
        this.dialogIsLoading = false;
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AssociateBalancesPlatformNoteDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     */
    AssociateBalancesPlatformNoteDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Handle select all properties
     *
     * @since 1.0.0
     */
    AssociateBalancesPlatformNoteDialogComponent.prototype.onSelectAll = function (checked) {
        this.selectAll = checked;
        if (!checked) {
            this.balances.forEach(function (balance) {
                balance["value"] = false;
            });
        }
        else if (checked) {
            this.balances.forEach(function (balance) {
                balance["value"] = true;
            });
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    AssociateBalancesPlatformNoteDialogComponent.prototype.onFormSubmit = function () {
        var _this = this;
        var balancesSelected = [];
        if (this.balances && Array.isArray(this.balances)) {
            this.balances.forEach(function (item) {
                if (item.value) {
                    balancesSelected.push(item.id);
                }
            });
        }
        var data = {
            balances: balancesSelected,
        };
        this.subscriptions.push(this.platformNotesService
            .updateNote(this.data.noteId, data)
            .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.onClose({ status: true });
                return;
            }
            _this.toastrService.error(_this.translateService.instant("common.errors.unknown_server_error"));
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Handle properties filtering
     *
     * @since 1.0.0
     */
    AssociateBalancesPlatformNoteDialogComponent.prototype.onFilterProperties = function () {
        if (this.filterProperty !== '') {
            this.selectAll = false;
        }
        var regex = new RegExp(this.filterProperty.trim().toLowerCase(), "gim");
        this.balances.forEach(function (el) {
            if ((el.number && el.number.search(regex) > -1)) {
                el.visible = true;
            }
            else {
                el.visible = false;
                el.value = false;
            }
        });
    };
    return AssociateBalancesPlatformNoteDialogComponent;
}());
export { AssociateBalancesPlatformNoteDialogComponent };
